import https from 'https'
import Vue from 'vue'
import qs from 'qs'
// import appConfig from '@/app.config'

class HttpService {

	constructor(app){
		this.app = app
	}

	graphql(query){
		if (this.app.store.state.config.skipHttpsValidation){
	 		let httpsAgent = new https.Agent({ rejectUnauthorized: false })
			return this.app.$axios.$post(this.app.store.state.config.graphqlUrl, {query}, {httpsAgent})
		}
		return this.app.$axios.$post(this.app.store.state.config.graphqlUrl, {query})
	}

	get(url, params){
		if (this.app.store.state.config.skipHttpsValidation){
			let httpsAgent = new https.Agent({ rejectUnauthorized: false })
			return this.app.$axios.$get(url, {params}, {httpsAgent})
		}
		return this.app.$axios.$get(url, {params})
	}

	delete(url, params){
		if (this.app.store.state.config.skipHttpsValidation){
			let httpsAgent = new https.Agent({ rejectUnauthorized: false })
			return this.app.$axios.$delete(url, {params}, {httpsAgent})
		}
		return this.app.$axios.$delete(url, {params})
	}

	post(url, params, jsonEncoded = true){
		if (jsonEncoded){
			if (this.app.store.state.config.skipHttpsValidation){
				let httpsAgent = new https.Agent({ rejectUnauthorized: false })
				return this.app.$axios.$post(url, params, {httpsAgent})
			}
			return this.app.$axios.$post(url, params)
		}
		if (this.app.store.state.config.skipHttpsValidation){
			let httpsAgent = new https.Agent({ rejectUnauthorized: false })
			return this.app.$axios.$post(url, qs.stringify(params), {httpsAgent})
		}
		return this.app.$axios.$post(url, qs.stringify(params))
	}

	test(string = "$httpService is working"){
		return
	}

}

export default ({app}) => {
	const httpService = new HttpService(app)
	app.$httpService = httpService
	Vue.prototype.$httpService = httpService
}
